import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import ManageLinkedUsers from "Tooling/routes/AccessManager/routes/ManageLinkedUsers";
import AddOnManager from "AddOnManager";
import { injectReducer } from "store/reducers";

export default store => ({
  path: "accessManagerV2",
  component: withAsyncRouteLoading(
    () =>
      Promise.all([
        import(
          /* webpackChunkName: "administrator-tooling" */ "./AccessManagerV2"
        ),
        import(
          /* webpackChunkName: "administrator-tooling" */ "Tooling/modules/ToolingModule"
        ),
      ]).then(([importedModule0, importedModule1]) => {
        const component = importedModule0.default;
        const reducer = importedModule1.default;
        injectReducer(store, {
          key: "tooling",
          reducer,
        });
        return component;
      })
    //.catch(err => {
    //   throw err;
    // })
  ),
  childRoutes: [AddOnManager(store), ManageLinkedUsers(store)],
});
